module.exports = __webpack_public_path__ + "static/media/Chatbot Appearance.46da70c4.png";